<template lang="pug">
.project-promo
  .project-promo__image-wrap
    component.project-promo__component-link(
      ref="imageLink"
      :is='value.project_page ? "a" : "div"')
      img.project-promo__image(:src="imgSrc")
  .project-promo__info
    .project-promo__name
      component.project-promo__title(
        ref="titleLink"
        :is='value.project_page ? "a" : "div"'
        :class="{'project-promo__title--link': value.project_page}")
        h1.project-promo__name-title {{ value.title }}
      p.project-promo__name-date {{ value.year }}
    .project-promo__description
      h3.project-promo__short-desc {{ value.paragraph_title }}
      .project-promo__details(v-html="value.paragraph")
  .project-promo__go-down(@click="scrollToElement")
    img(src="~assets/images/svg/icons/go_down.svg").project-promo__go-down-img
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill'
import { useMediaQuery } from '@vueuse/core'
import { small } from '~/helpers/breakpoints'

export default {
  setup() {
    const isBreakpointMedium = reactive({})

    return {
      isBreakpointMedium,
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    imgSrc() {
      if (this.isBreakpointMedium.value !== undefined) {
        if (this.value?.image_locale === 'static') {
          return this.isBreakpointMedium.value ? this.value.image_mini.download_path : this.value.image.download_path
        }
        return this.isBreakpointMedium.value ? this.$getImgUrl.origin(this.value.image_mini.download_path) : this.$getImgUrl.origin(this.value.image.download_path)
      }
      return ''
    },
  },
  mounted() {
    this.isBreakpointMedium.value = useMediaQuery(small)
    this.setLinkAttribute()
  },
  methods: {
    scrollToElement() {
      const elements = document.getElementsByClassName('scrollto')

      if (elements && elements.length) {
        const elementPosition = elements[0].getBoundingClientRect().top
        const offsetPosition = elementPosition - 20;
        smoothscroll.polyfill(
          window.scrollBy({
            top: offsetPosition,
            behavior: 'smooth'
          })
        )
      }
    },
    scrollToBottom() {
      const scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight
      )

      smoothscroll.polyfill(window.scroll({
        top: scrollHeight,
        behavior: "smooth"
      })
      )
    },
    setLinkAttribute() {
      if (this.value?.project_page?.slug) {
        Object.values(this.$refs).map((el) => el.setAttribute('href', `${this.value.project_page.slug}`)
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.project-promo {
  width: 100%;
  margin-bottom: 180px;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (min-width: $breakpoint-medium) {
    &:first-of-type {
      .project-promo__go-down {
        display: flex;
      }
    }
  }

  &__component-link {
    display: block;
    height: 100%;
  }

  &__go-down {
    width: 100%;
    height: 100px;
    display: none;
    justify-content: center;
    align-items: center;
  }

  &__go-down-img {
    cursor: pointer;
    display: block;
  }

  &__image-wrap {
    margin-bottom: 43px;
    background-image: var(--url);

    @include notebook {
      margin-bottom: 30px;
      object-fit: cover;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 180px;
  }

  &__info {
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-medium) {
      flex-direction: row;
    }
  }

  &__name {
    width: 100%;
    margin-right: 25px;

    @media (min-width: $breakpoint-medium) {
      max-width: 330px;
      margin-right: 60px;
    }

    @include notebook {
      margin-right: 20px;
      flex-basis: 314px;
      flex-shrink: 0;
    }
  }

  &__name-title {
    font-size: 30px;
    color: inherit;
    margin-bottom: 15px;
    line-height: 48px;

    @media (min-width: $breakpoint-medium) {
      font-size: 34px;
    }

    @include notebook {
      margin-bottom: 0;
      line-height: 42px;
    }
  }

  &__name-date {
    display: none;
    color: $primary;
    font-size: 13px;

    @media (min-width: $breakpoint-medium) {
      display: inline;
      color: $primary;
    }
  }

  &__short-desc {
    color: $dark;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &__details {
    color: $dark;
  }

  &__title {
    text-decoration: none;
    color: $primary;

    &--link {
      &:hover {
        color: $purple;
      }
    }
  }
}
</style>
